export const LOGIN = 'LOGIN'
export const LOGIN_MFA = 'LOGIN_MFA'
export const LOGOUT = 'LOGOUT'
export const ME = 'auth/ME'
